// src/helpers/settings/register.ts
var dateSliderHasErrorValue = (value, bannedRanges) => {
  const result = bannedRanges.some(
    (range) => range[0] >= value[0] && range[0] < value[1] || range[1] > value[0] && range[1] <= value[1] || value[0] >= range[0] && value[0] < range[1] || value[1] > range[0] && value[1] <= range[1]
  );
  return result;
};
var indexSliderHasErrorValue = ({
  index,
  value,
  bannedRanges
}) => {
  return bannedRanges == null ? void 0 : bannedRanges.some((range) => {
    if (index === 0) {
      return value >= range[0] && value < range[1];
    } else {
      return value > range[0] && value <= range[1];
    }
  });
};

export { dateSliderHasErrorValue, indexSliderHasErrorValue };
